import type { FC } from "react";
import { usePortfolioDocumentsQuery } from "web_myplann/Api/Portfolio/Queries/usePortfolioDocumentsQuery";
import type { PropertyInsuranceDetailDataDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailCard } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailCard";
import { DetailDates } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailDates";
import { DetailLoader } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailLoader";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { RelatedSectionRedesign } from "web_myplann/Portfolio/Components/Redesign/Detail/RelatedSectionRedesign";
import { PortfolioBasicInfoRows } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/PortfolioBasicInfoRows";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";
import type { PortfolioDetailProps } from "web_myplann/Utils/types";

const PageResources = Resources.PortfolioDetail.NonLifeInsurance;

export const PropertyInsuranceRedesign: FC<PortfolioDetailProps> = ({
	baseData,
	currencySign,
}) => {
	const { t } = useResource();

	const { data: documents, isLoading: isDocumentsLoading } =
		usePortfolioDocumentsQuery(baseData.id);

	if (isDocumentsLoading) {
		return <DetailLoader />;
	}

	const portfolioData = baseData.data as PropertyInsuranceDetailDataDTO;

	return (
		<>
			<DetailCard label={t(Resources.DataCard.BasicInfo.title)}>
				<PortfolioBasicInfoRows baseData={baseData} />
				<DetailRow
					label={t(PageResources.insured)}
					value={moneyFormatter(portfolioData?.insurance, currencySign)}
				/>
				<DetailRow
					label={t(PageResources.insurancePeriod)}
					value={moneyFormatter(portfolioData?.insurancePeriod, currencySign)}
				/>
			</DetailCard>
			<DetailDates data={baseData} />

			<RelatedSectionRedesign
				documents={documents?.data}
				related={baseData.related}
				readOnly={baseData.archived}
				itemKind={PortfolioItemKind.Portfolio}
				portfolioId={baseData.id}
			/>
		</>
	);
};
